import React, { useRef, useMemo } from "react";
import { useGlobalSticky } from "./useGlobalSticky";

// Z-index values aligned with planner strata (see plannerVariables.scss, e.g. $plannerStrata: (header: 12, ...))
const ELEVATED_Z_INDEX = 12;
const DEFAULT_Z_INDEX = 11;

const StickyOffsetHeader = ({ children, elevatedZIndex }: { children: React.ReactNode, elevatedZIndex?: boolean }) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const { top } = useGlobalSticky(ref);

    const style = useMemo(() => ({
        position: "absolute" as const,
        zIndex: elevatedZIndex ? ELEVATED_Z_INDEX : DEFAULT_Z_INDEX,
        top,
        transition: top > 0 ? "top 0.1s" : undefined,
    }), [top, elevatedZIndex]);

    return (
        <div ref={ref} style={style}>
            {children}
        </div>
    );
};

export default StickyOffsetHeader;
